module.exports = __webpack_public_path__ + "media/honey-icons/icon-tick-4605bd79.svg";